export interface Schema {
  skipPackageJson?: boolean;
}
